// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import App from './App'
import createRouter from './router'
import i18n from './i18n'                                 // 国际化
import store from './store'
import infiniteScroll from 'vue-infinite-scroll'          // 无线滚动
import { Image } from 'element-ui'

// 样式文件
import 'element-ui/lib/theme-chalk/base.css'
import '@assets/font/iconfont.css'                        // 字体图标PC
import '@assets/fontIcon/iconfont.css'                        // 字体图标PC
import './assets/css/common.css'                          // 公共CSS
import './assets/css/width.scss'                          // 公共CSS
import './assets/css/transition.css'                      // 自定义动画css
import 'vue-country-intl/lib/vue-country-intl.css'

// 工具和API
import $utils from '@assets/utils'                        // 公共自定义钩子函数
import * as $api from '@assets/api'                       // api请求函数
import getCommon from '@assets/api/js/common'             // 公共的缓存请求
import $constant from '@assets/js/constant.js'
import elementJs from '@assets/utils/elementJs'           // 自定义引入element-ui
import Bus from './bus/bus'                                 // 事件总线
import emoji from './assets/js/emoji'                   // emoji过滤
import scrollLock from './assets/js/body-scroll-lock.js'                   // 滚动锁定
import VueAnimateOnScroll from './assets/js/vue-animate-onscroll'                   // emoji过滤
import Cookie from './assets/js/Cookie'                   // Cookie
import elSelectLoadmore from './assets/js/elSelectLoadmore' // el-select 加载更多

// 路由钩子
import beforeEach from './router/route-hook/beforeEach'   // 引入路由钩子跳转前公共函数
import afterEach from './router/route-hook/afterEach'     // 引入路由钩子跳转后公共函数

// 插件和指令
import BloomPlugins from './plugin/index'                 // 引入公共插件
import LeonInstruction from './instruction'               // 引入公共指令
import vFilter from './filters'                           // 引入公共过滤器
import myMixin from './mixin/common'                      // 引入公共混淆

// 组件
import Popup from './components/popup/index'
import PaymentGuideDialog from './components/public/PaymentGuideDialog.vue'
import LazyViewer from './components/public/LazyViewer.vue'

// 尽早注册 v-lazy，避免路由/组件先于指令注册导致 Failed to resolve directive: lazy
Vue.use(VueLazyload, {
  preLoad: 1.2,
  attempt: 1
})
// vue-animate-number 改为在 DataComponent 等使用处按需加载

Vue.component('PaymentGuideDialog', PaymentGuideDialog)
Vue.component('LazyViewer', LazyViewer)
// import VueAnimateOnScroll from 'vue-animate-onscroll'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper) /* { default global options } */
// Vue.use(VueAnimateOnScroll)
// import VueAnimateOnScroll from 'vue-animate-onscroll'
Vue.use(VueAnimateOnScroll)
Vue.directive('emoji', emoji)
Vue.directive('scroll-lock', scrollLock)
Vue.directive('el-select-loadmore', elSelectLoadmore)
Vue.use(Cookie)               // 拿Cookie
// Vue.use(ScrollNumber)
Vue.use(LeonInstruction)                                  // 引入自定义指令
Vue.use(Image)
Vue.use(infiniteScroll)
Vue.filter('imageFormat', (val) => {
  // return `${val}?x-oss-process=image/format,jpg/quality,q_70`
  return `${val}?x-oss-process=image/format,jpg/quality,q_70`
})
Vue.prototype.$utils = $utils
Vue.prototype.$constant = $constant
Vue.prototype.$api = $api
Vue.prototype.$getCommon = getCommon
Vue.prototype.$popup = Popup.install
Vue.prototype.$bus = Bus

elementJs()                                               // 自定义引入element-ui
Vue.use(vFilter)                                          // 引入公共过滤器
Vue.use(BloomPlugins)                                     // 自定义ui插件
Vue.use(myMixin)                                          // 公共混淆

Vue.config.productionTip = false

// 全局异常捕获 - Vue组件内部异常
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue组件内部异常:', err, info)
  // 上报异常日志
  $api.logPost({
    a: 90001, // 错误类型码，90001表示Vue组件内部异常
    c: 'Vue组件内部异常',
    r: window.location.pathname,
    e: err.message,
    detail: info,
    stack: err.stack,
    ua: navigator.userAgent
  })
}

// 全局异常捕获 - JavaScript运行时异常
window.onerror = function (message, source, lineno, colno, error) {
  console.error('JavaScript运行时异常:', message, source, lineno, colno, error)
  // 上报异常日志
  $api.logPost({
    a: 90002, // 错误类型码，90002表示JavaScript运行时异常
    c: 'JavaScript运行时异常',
    r: window.location.pathname,
    e: message,
    source: source,
    lineno: lineno,
    colno: colno,
    stack: error ? error.stack : '',
    ua: navigator.userAgent
  })
  // 返回true表示阻止默认事件处理
  return true
}

// 全局异常捕获 - Promise异常
window.addEventListener('unhandledrejection', function (event) {
  console.error('Promise异常:', event.reason)
  // 上报异常日志
  $api.logPost({
    a: 90003, // 错误类型码，90003表示Promise异常
    c: 'Promise异常',
    r: window.location.pathname,
    e: event.reason ? event.reason.message : 'Promise异常',
    stack: event.reason ? event.reason.stack : '',
    ua: navigator.userAgent
  })
})

// 路由定义改为动态 import，先加载子路由再挂载应用；只调用一次 createRouter
const appPromise = createRouter().then(router => {
  router.beforeEach((to, from, next) => {
    beforeEach(to, from, next)
  })
  router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g
    const isChunkLoadFailed = error.message.match(pattern)
    if (isChunkLoadFailed) {
      window.location.reload()
    } else {
      console.log(error)
    }
  })
  router.afterEach((to, from, next) => {
    afterEach(to, from, next)
  })

  return new Vue({
    el: '#app',
    store,
    i18n,
    router,
    components: { App },
    template: '<App/>'
  })
})

// 默认导出 Promise<Vue实例>，便于 await import('./main') 后拿到实例
export default appPromise



// WEBPACK FOOTER //
// ./src/main.js